import script from "./ThemeConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeConfig.vue?vue&type=script&setup=true&lang=js"

import "./ThemeConfig.vue?vue&type=style&index=0&id=47666cea&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47666cea"]])

export default __exports__